import BioM1 from "./BioM/Slide1.JPG";
import BioM2 from "./BioM/Slide2.JPG";
import BioM3 from "./BioM/Slide3.JPG";
import BioM4 from "./BioM/Slide4.JPG";

import Biotech1 from "./Biotech/Slide1.JPG";
import Biotech2 from "./Biotech/Slide2.JPG";
import Biotech3 from "./Biotech/Slide3.JPG";
import Biotech4 from "./Biotech/Slide4.JPG";

import ceutix1 from "./ceutix/Slide1.JPG";
import ceutix2 from "./ceutix/Slide2.JPG";
import ceutix3 from "./ceutix/Slide3.JPG";
import ceutix4 from "./ceutix/Slide4.JPG";

import Chem1 from "./Chem/Slide1.JPG";
import Chem2 from "./Chem/Slide2.JPG";
import Chem3 from "./Chem/Slide3.JPG";
import Chem4 from "./Chem/Slide4.JPG";

import Control1 from "./Control/Slide1.JPG";
import Control2 from "./Control/Slide2.JPG";
import Control3 from "./Control/Slide3.JPG";
import Control4 from "./Control/Slide4.JPG";

import Economy1 from "./Economy/Slide1.JPG";
import Economy2 from "./Economy/Slide2.JPG";
import Economy3 from "./Economy/Slide3.JPG";
import Economy4 from "./Economy/Slide4.JPG";

import genozy1 from "./genozy/Slide1.JPG";
import genozy2 from "./genozy/Slide2.JPG";
import genozy3 from "./genozy/Slide3.JPG";
import genozy4 from "./genozy/Slide4.JPG";

import Nano1 from "./Nano/Slide1.JPG";
import Nano2 from "./Nano/Slide2.JPG";
import Nano3 from "./Nano/Slide3.JPG";
import Nano4 from "./Nano/Slide4.JPG";

import Nuclear1 from "./Nuclear/Slide1.JPG";
import Nuclear2 from "./Nuclear/Slide2.JPG";
import Nuclear3 from "./Nuclear/Slide3.JPG";
import Nuclear4 from "./Nuclear/Slide4.JPG";

import therapy1 from "./therapy/Slide1.JPG";
import therapy2 from "./therapy/Slide2.JPG";
import therapy3 from "./therapy/Slide3.JPG";
import therapy4 from "./therapy/Slide4.JPG";

import Toxico1 from "./Toxico/Slide1.JPG";
import Toxico2 from "./Toxico/Slide2.JPG";
import Toxico3 from "./Toxico/Slide3.JPG";
import Toxico4 from "./Toxico/Slide4.JPG";

import Traditional1 from "./Traditional/Slide1.JPG";
import Traditional2 from "./Traditional/Slide2.JPG";
import Traditional3 from "./Traditional/Slide3.JPG";
import Traditional4 from "./Traditional/Slide4.JPG";

const allImages = [
  { title: "زیست-مواد-دارویی", images: [BioM1, BioM2, BioM3, BioM4] },
  {
    title: "بیوتکنولوژی-دارویی",
    images: [Biotech1, Biotech2, Biotech3, Biotech4],
  },
  {
    title: "فارماسیوتیکس",
    images: [ceutix1, ceutix2, ceutix3, ceutix4],
  },
  { title: "شیمی-دارویی", images: [Chem1, Chem2, Chem3, Chem4] },
  {
    title: "کنترل-دارو-و-غذا",
    images: [Control1, Control2, Control3, Control4],
  },
  {
    title: "اقتصاد-و-مدیریت-دارو",
    images: [Economy1, Economy2, Economy3, Economy4],
  },
  {
    title: "فارماکوگنوزی",
    images: [genozy1, genozy2, genozy3, genozy4],
  },
  { title: "نانوفناوری-دارویی", images: [Nano1, Nano2, Nano3, Nano4] },
  {
    title: "داروسازی-هسته‌ای",
    images: [Nuclear1, Nuclear2, Nuclear3, Nuclear4],
  },
  {
    title: "داروسازی-بالینی",
    images: [therapy1, therapy2, therapy3, therapy4],
  },
  {
    title: "سم‌شناسی-و-داروشناسی",
    images: [Toxico1, Toxico2, Toxico3, Toxico4],
  },
  {
    title: "داروسازی-سنتی",
    images: [Traditional1, Traditional2, Traditional3, Traditional4],
  },
];

export default allImages;
